import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            热门娱乐视频合集，精彩内容不容错过
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div key={i} className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative w-full h-[180px] md:h-[200px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute bottom-3 right-3 text-[10px] px-2 py-1 rounded-md bg-black/60 text-white font-medium whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                </div>
              </div>
              <div className="p-4">
                <span className="text-[10px] text-accent-600 font-medium">{item.category}</span>
                <h3 className="text-sm font-semibold text-foreground-900 mt-1 line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}